import { createContext } from 'react'

import type { BrandRankingContextData } from './types'

export const BrandRankingContext = createContext<BrandRankingContextData | null>(null)
